import React, { Component } from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
import * as User from '../helpers/User';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getProfile} from '../actions/profileAction';
const $= window.$;
const jQuery=window.jQuery;

class ProfileEdit extends Component {
	constructor(props) {
		super(props);
        this.state={

			txtStudying: '',
			cmbYearofstudy : '',
			txtdob :'',
			firstname : '',
			lastname : '',
			txtCollege : '',
			txtcoll_name : '',
			oth_others :'',
			oth_rLocation :'',
			txtaboutyourself :'',
			cmbcountrycode :'',
			txtmob : '',
			txtCityTown : '',
			txtRegionstate : '',
			com_cmbCountry : '',
			checkedGenderOption : '',
			lstexpmonths : '',
			lstexpyrs : '',
			occupation : '',
			photo : '',
			wor_designation:'',
			wor_Education:'',
			wor_office_Location:'',
         	details : [],
         	corp:[],
         	getcountrycodes:[],
		    locations:[],
		    cities:[],
		    tr_student:'',
		    tr_Working:'none',
		    othershow:'none',
		    hidOccupation:'',
		    but_show:'',

        };

        this.remove = this.remove.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.props.getProfile();

	}

	componentWillReceiveProps(nextProps) {
	
         if(nextProps.sentdetails!=undefined){

         	//alert(JSON.stringify(nextProps.sentdetails.learner));
			let details=nextProps.sentdetails;
         	this.setState({
         		details : details.learner,
         		corp: details.corp,
         		txtStudying: (details.learner.studying!=undefined)?details.learner.studying:'',
         		cmbYearofstudy : details.learner.yearofstudy?details.learner.yearofstudy:'',
         		txtdob : details.corp.dob?details.corp.dob:'',
         		txtCollege : details.learner.location?details.learner.location:'',
         		txtcoll_name : details.learner.college? details.learner.college:'',
         		wor_designation : details.learner.designation?details.learner.designation:'',
         		wor_Education : details.learner.education?details.learner.education:'',
         		wor_office_Location : details.learner.location?details.learner.location:'',
         		oth_others : details.learner.others?details.learner.others:'',
         		oth_rLocation : details.learner.location?details.learner.location:'',
         		txtaboutyourself : details.learner.aboutyourself?details.learner.aboutyourself:'',
         		cmbcountrycode : details.learner.country_code?details.learner.country_code:'',
         		txtmob : details.learner.mobile?details.learner.mobile:'',
				 firstname : details.learner.firstname?details.learner.firstname:'',
				 lastname : details.learner.lastname?details.learner.lastname:'',
         		txtCityTown : details.learner.citytown?details.learner.citytown:'',
         		txtRegionstate : details.learner.regionstate?details.learner.regionstate:'',
         		com_cmbCountry : details.learner.country?details.learner.country:'',
         		checkedGenderOption : details.learner.gender?details.learner.gender:'',
         		lstexpmonths : details.corp.month?details.corp.month:'',
         		lstexpyrs : details.corp.year?details.corp.year:'',
         		occupation : details.learner.occupation?details.learner.occupation:'',
         		photo : details.corp.photo?details.corp.photo:'',
         		but_show : details.corp.but_show?details.corp.but_show:'',

         	})



         }

    }
   handleChange(e){

				  this.setState({
							[e.target.name]:e.target.value
						})

   }



  gender(value){
  	//alert(value);
    this.setState({checkedGenderOption:value});
  }


  onSubmit(){
  		 let formData = new FormData();
		 let frm_myaccount=$('#frm_myaccount').serializeArray();
		 let learnerID = Common.getUserData("id", true);
		 let domain = Config.domainUrl;
		  formData.append('learner_id',learnerID);
		  formData.append('domain',domain);

		   let details = [];

		   frm_myaccount.map((key,index)=>{
		       if(key.name=='hidfilename'){ return false; }
		       details.push({[key.name]:key.value});
		       formData.append(key.name,key.value);
		   });



		   if($('#txtfile')[0].files.length>0){
		   	// alert('here');
		    formData.append('txtfile',$('#txtfile')[0].files[0]);
		   }else{
		   	// alert('here ony');
		    formData.append('txtfile','');
		   }

		  // alert(JSON.stringify(details));
		Common.reactLoader("show", "Please wait...");
		  

		fetch(Config.domainUrl +"user/update-registerdetails", {
		     method: "POST",
			   // data: formData,

			   headers: {
			       'Accept': 'application/json',
				   'Authorization':'Bearer ' +Common.getTokenData()
			       // 'Content-Type': false

			      },
			    body: formData,
			   }).then((response) => response.json()).then((responseJson) => {
			    Common.reactLoader("hide");

			    if (responseJson.status == 0) {

			       Common.message(responseJson.message,responseJson.errors,'error');

			    }else{

			      $('#txtfile').val('');
				  // let pho =responseJson.lr_photo;				  
				  // Common.setUserData('photo_lr',pho,true);
			   //    this.props.active(pho);
				  this.props.getProfile();
			      Common.message('Success',responseJson.message,'success');





			    }


		});
  }

  getcountrycodes(){
   fetch(Config.domainUrl +"getcountrycodes", {
    method: "GET",
    headers: {
     'Accept': 'application/json',
     'Content-Type': 'application/json',
	 'Authorization':'Bearer ' +Common.getTokenData()
    }
   }).then((response) => response.json()).then((responseJson) => {
   	//alert(JSON.stringify(responseJson));
    this.setState({getcountrycodes:responseJson.country_data});
   });
  }

  getlocations_cities(){
   fetch(Config.domainUrl +"getlocationscities", {
    method: "GET",
    headers: {
     'Accept': 'application/json',
     'Content-Type': 'application/json',
	 'Authorization':'Bearer ' +Common.getTokenData()
    }
   }).then((response) => response.json()).then((responseJson) => {
   	 //alert(JSON.stringify(responseJson));
    this.setState({
     locations:responseJson.location,
     cities:responseJson.city
    });
   });
  }





    componentDidMount() {

       $('.edit_form').css('display', 'block');

       this.getcountrycodes();
	   this.getlocations_cities();


	   // setTimeout(function(){
	    $("#txtdob").datepicker({
	     dateFormat: 'yy-mm-dd' ,
	     changeMonth: true,
	     changeYear: true,
	     yearRange: "-70:-15",
	     maxDate:'15Y',
	     onSelect:function(selected,evnt){

				this.setState({
					txtdob: selected
				});
			}.bind(this)

	    });

	   // },100);



    }

	remove(){
		Common.reactLoader("show", "Please wait...");
	    let lr_id = Common.getUserData("id", true);
	    let domain = Config.domainUrl;
   		fetch(Config.domainUrl +"user/remove-photo", {
	        method: "POST",
	        headers: {
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
				'Authorization':'Bearer ' +Common.getTokenData()
	          },
	        body: JSON.stringify({
			        learner_id:lr_id,
			        domain : domain,
                  })
	       }).then((response) => response.json()).then((responseJson) => {
	       	 	Common.reactLoader("hide");
	       	 	//alert(JSON.stringify(responseJson));
	       		 if (responseJson.status == 0) {
			        Common.message(responseJson.message, responseJson.errors, "error");
			      } else {
			      
			      	this.setState({
			      		photo : responseJson.datas,
			      		but_show : responseJson.btn_show,
			      	})
			  //     	let pho = "";
					// Common.setUserData('photo_lr',pho,true);
			      	// this.props.active('');
			      	this.props.getProfile();
			        Common.message("", responseJson.message , "success");
			      }
	       });
	}



		render() {


			//const {sentdetails} = this.props;
		//alert(JSON.stringify(this.state.getcountrycodes));
		
			let edit = this.state.but_show;
			// let ph = this.state.but_show;
			(edit != 2) ? edit =   <div className="remove-btn">
				                         <input type="button" value="Remove" name="img_remove" className="remove" alt="Remove" title="Remove" onClick={(e)=>this.remove(e)}/>
				                    </div>
				         :
				            edit = '';

		   let occupation = this.state.details.occupation;


		   (occupation == 1) ? $("#tr_student").css('display','block')

		   					 : (occupation == 2) ?
							   					    $("#tr_Working").css('display','block')

							   					 :  (occupation == 3) ?

							   					    $("#othershow").css('display','block')
							   					 : '';
		   let contryCodeoptions = null;
		   if(this.state.getcountrycodes!=undefined || this.state.getcountrycodes!=null){
			   contryCodeoptions=this.state.getcountrycodes.map((key,index)=>
			   <option key={index} value={key.id}>{key.name_code}</option>
			   );
			}

		   let contryoptions = null;
		   if(this.state.getcountrycodes!=undefined || this.state.getcountrycodes!=null){
			   contryoptions=this.state.getcountrycodes.map((key,index)=>
			   <option key={index} value={key.id}>{key.name}</option>
			   );
			}

		   let locations = null;
		   if(this.state.locations!=undefined || this.state.locations!=null){
			   locations=this.state.locations.map((key,index)=>
			   <option key={index} value={key.name}>{key.name}</option>
			   );
			}

			let cities = null;
		   if(this.state.cities!=undefined || this.state.cities!=null){
			   cities=this.state.cities.map((key,index)=>
			   <option key={index} value={key.name}>{key.name}</option>
			   );
			}
			let productID = Common.getUserData('productID', true);
			let corporateID = Common.getUserData('corporateID', true);

			return (
				<div>
					<form name="frm_myaccount" id="frm_myaccount">
						{/*<input type="hidden" name="learner_id" value={learnerID} />
						<input type="hidden" name="domain" value={domain} />*/}
						<div className="acc-lft edit_form">
				        	<div className="profile-top">
				                <div className="pphoto" dangerouslySetInnerHTML={{__html: this.state.photo}}/>
			                    <div className="profile-rht">

			                        <ul className="pro-list">
			                            <li>Profile image should have minimum width 200px and minimum height of 200px</li>
			                            <li>Make sure to save changes after changing the image.</li>
			                        </ul>
			                         {edit}
			                    </div>
								<ul className="pro-right">
									<li><label>Customer Name</label>
									<span className="box-name">{this.state.corp.corporate}</span></li>
									<li><label>First Name</label>
									{(this.state.details.firstname_lastname_only_once!=0) ?
										<span>{this.state.details.firstname}</span> 
										:
										<div className="profilevalidiv">
										<input type="text" className="textbox" style={{background:'#fff'}}  name="firstname" id="firstname" value={(this.state.firstname=='-')?'':this.state.firstname} onChange={(e)=>this.handleChange(e)} />
										</div>
										
									}
																		 
									</li>
									<li><label>Last Name</label>
									{(this.state.details.firstname_lastname_only_once!=0) ?
										<span>{this.state.details.lastname}</span> 
										:
										 <div className="profilevalidiv">
										<input type="text" name="lastname" style={{background:'#fff'}}  className="textbox"  id="lastname" value={(this.state.lastname=='-')?'':this.state.lastname} onChange={(e)=>this.handleChange(e)}  />
										</div>
									}
									
									</li>
									<li><label>Email Id</label>
									<span>{this.state.details.email}</span></li>
								</ul>
				             </div>
				        </div>
				        <div className="acc-inner-left edit_form">
							<ul>
								<li><label>Upload Photo</label>
								  	<input type="file" id="txtfile" accept="image/*" name="txtfile" className="uploadfile" />
								  	 <input name="hidfilename" type="hidden" id="hidfilename" value="" />
								</li>
								{(productID!=418 && productID!=419) ?
							     <li><label>Date of Birth <span className="redtext">*</span></label>
								    <div className="profilevalidiv">
								        <input type="text" name="txtdob" className="txtdob active-textbox" id="txtdob" value={this.state.txtdob}  />
								    </div>
							    </li>
									: ''
								}
							    <div id="tr_student" style={{display:'none'}}>

			                       <li><label>Dept of study<span className="redtext">*</span></label>
			                           <input name="txtStudying" id="txtStudying" type="text" value={(this.state.txtStudying=='-')?'':this.state.txtStudying} onChange={(e)=>this.handleChange(e)}/>
			                            <input name="hidOccupation" type="hidden" id="hidOccupation" value={this.state.occupation} />
			                       </li>
			                       <li><label>Year of study <span className="redtext">*</span></label>
			                           <select name="cmbYearofstudy" id="cmbYearofstudy" value={this.state.cmbYearofstudy} onChange={(e)=>this.handleChange(e)}>
			                             <option value="">-- Select --</option>
			                             <option value="1">I</option>
			                             <option value="2">II</option>
			                             <option value="3">III</option>
			                             <option value="4">IV</option>
			                           </select>
			                       </li>
			                       <li><label>College Location<span className="redtext">*</span> </label>
			                         <input type="text" className="textbox"  name="txtCollege" id="txtCollege" value={(this.state.txtCollege=='-')?'':this.state.txtCollege}  onChange={(e)=>this.handleChange(e)}/>
			                       </li>
			                       <li><label>College Name<span className="redtext">*</span></label>
			                       	 <input type="text" className="textbox" name="txtcoll_name" id="txtcoll_name" value={(this.state.txtcoll_name=='-')?'':this.state.txtcoll_name} onChange={(e)=>this.handleChange(e)}/>
			                       </li>
			                    </div>
			                    <div id="tr_Working" style={{display:'none'}}>
			                        <li><label>Designation <span className="redtext">*</span></label>
			            <input name="wor_designation" id="wor_designation" type="text" value={this.state.wor_designation} onChange={(e)=>this.handleChange(e)}/>
			                        </li>
			                        <li><label>Experience <span className="redtext">*</span></label>
			                           <select name="lstexpyrs" id="lstexpyrs" value={this.state.lstexpyrs} onChange={(e)=>this.handleChange(e)}>
			                             <option value="0" >0</option>
			                             <option value="1" >1</option>
			                             <option value="2" >2</option>
			                             <option value="3" >3</option>
			                             <option value="4" >4</option>
			                             <option value="5" >5</option>
			                             <option value="6" >6</option>
			                             <option value="7" >7</option>
			                             <option value="8" >8</option>
			                             <option value="9" >9</option>
			                             <option value="10" >10</option>
			                             <option value="11" >11</option>
			                             <option value="12" >12</option>
			                             <option value="13" >13</option>
			                             <option value="14" >14</option>
			                             <option value="15" >15</option>
			                             <option value="16" >16</option>
			                             <option value="17" >17</option>
			                             <option value="18" >18</option>
			                             <option value="19" >19</option>
			                             <option value="20" >20</option>
			                             <option value="21" >21</option>
			                             <option value="22" >22</option>
			                             <option value="23" >23</option>
			                             <option value="24" >24</option>
			                             <option value="25" >25</option>
			                           </select>
			                           Yrs  &nbsp;  &nbsp;  &nbsp;  &nbsp; <label>
			                           <select name="lstexpmonths" id="lstexpmonths" value={this.state.lstexpmonths}  onChange={(e)=>this.handleChange(e)}>
			                             <option value="0" >0</option>
			                             <option value="1" >1</option>
			                             <option value="2" >2</option>
			                             <option value="3" >3</option>
			                             <option value="4" >4</option>
			                             <option value="5" >5</option>
			                             <option value="6" >6</option>
			                             <option value="7" >7</option>
			                             <option value="8" >8</option>
			                             <option value="9" >9</option>
			                             <option value="10" >10</option>
			                             <option value="11" >11</option>
			                           </select>
			                           Months </label>

			                        </li>
			                        <div className="clear"></div>
			                        <li><label>Education <span className="redtext">*</span></label>
			                           <input type="text" name="wor_Education" id="wor_Education" value={(this.state.wor_Education=='-')?'':this.state.wor_Education}  onChange={(e)=>this.handleChange(e)}/>
			                        </li>
			                        <li><label>Office Location <span className="redtext">*</span></label>

			                          <input name="wor_office_Location" id="wor_office_Location" value={(this.state.wor_office_Location=='-')?'':this.state.wor_office_Location}  type="text" onChange={(e)=>this.handleChange(e)}/>

			                        </li>
			                        <div className="clear"></div>
			                    </div>
			                    <div id="othershow" style={{display:'none'}}>
			                       <li><label>Occupation<span className="redtext">*</span></label>
			                           <input name="oth_others" id="oth_others"  type="text" value={(this.state.oth_others=='-')?'':this.state.oth_others} onChange={(e)=>this.handleChange(e)}/>
			                       </li>
			                       <li><label>Location<span className="redtext">*</span></label>

			                          <input name="oth_rLocation"  id="oth_rLocation" type="text"  value={(this.state.oth_rLocation=='-')?'':this.state.oth_rLocation} onChange={(e)=>this.handleChange(e)}/>
			                       </li>
			                       <div className="clear"></div>
			                     </div>
								<li><label className="label-txt">Additional info about Me</label>
							         <textarea name="txtaboutyourself" id="txtaboutyourself" value={(this.state.txtaboutyourself=='-')?'':this.state.txtaboutyourself} className="active-textbox" onChange={(e)=>this.handleChange(e)}>{(this.state.txtaboutyourself=='-')?'':this.state.txtaboutyourself}</textarea>
							    </li>
							</ul>
						</div>

						<div className="acc-inner-left acc-inner-rht edit_form">
						 	<ul>
						 	    <li><label>Gender</label>
							        <div className="profilevalidiv genderborder">
										    <input name="optgender" type="radio" value="1" checked={this.state.checkedGenderOption==1} onChange={e=>this.gender(1)}/>Male &nbsp;  &nbsp;
							                <input name="optgender" type="radio" value="2" checked={this.state.checkedGenderOption==2} onChange={e=>this.gender(2)}/>Female
							         </div>
								</li>
						     	<li className="limobno"><label>Mobile No<span className="redtext">*</span></label>
						           	<div className="mobile-no">
						           		<select name="cmbcountrycode" id="cmbcountrycode"  value={this.state.cmbcountrycode} onChange={(e)=>this.handleChange(e)}>
						                 <option value="">Select</option>
						                 {contryCodeoptions}
						               </select>
						               <span>Country code</span>
						            </div>
						        </li>

						        {(corporateID!=93) ? 
								<li><label>&nbsp;</label>
                                    <div className="mobile-no">
						               <input type="text" name="txtmob" id="txtmob" className="txtbox" maxLength="10" value={this.state.txtmob} onChange={(e)=>this.handleChange(e)}/>
						               <span>Mobile Number</span>
						            </div>
								</li> :
								<li><label>&nbsp;</label>
									<div className="mobile-no">
									<input type="text" name="txtmob" id="txtmob" readonly className="txtbox" maxLength="10" value={this.state.txtmob}/>
									<span>Mobile Number</span>
									</div>
								</li> 
								}

						        <li><label>City / Town <span className="redtext">*</span></label>
						        	<div className="profilevalidiv">
						              <input type="text" className="textbox"  name="txtCityTown" id="txtCityTown" value={(this.state.txtCityTown=='-')?'':this.state.txtCityTown} onChange={(e)=>this.handleChange(e)} />
						             </div>
						        </li>
						        <li><label>Region / State <span className="redtext">*</span></label>
						        	<div className="profilevalidiv">
						              	<input type="text" className="textbox" name="txtRegionstate" id="regionstate" value={(this.state.txtRegionstate=='-')?'':this.state.txtRegionstate} onChange={(e)=>this.handleChange(e)}/>
						            </div>
						         </li>
						        <li><label>Country <span className="redtext">*</span></label>
									<select name="com_cmbCountry" id="country_options" value={this.state.com_cmbCountry} onChange={(e)=>this.handleChange(e)}>
							         <option value=''>Select</option>
							         {contryoptions}
							       </select>
							       <br/>
								</li>
						  	</ul>
						</div>
						<div className="acc-btn edit_form">
							<input type="button" value="Save" id="edit" name="" className="edit" alt="Save" title="Save" onClick={(e)=>this.onSubmit(e)}/>
						    <span className="redtext">* </span>Required fields
						</div>
					</form>
				</div>

			);
		}
}


function mapStateToProps(state, ownProps) {      
  
  return {
    profile: state.profile
  };
}

function mapDispatchToProps(dispatch) {
      
  return  bindActionCreators({getProfile}, dispatch);
 
}

export default connect(mapStateToProps,mapDispatchToProps)(ProfileEdit);


// WEBPACK FOOTER //
// ./src/my_profile/ProfileEdit.js